import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Devicepersian_Interface, Empty_Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DevicepersianService } from 'src/app/Service/Devicepersian/Devicepersian.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DevicepersianAdd',
  templateUrl: './DevicepersianAdd.component.html',
  styleUrls: ['./DevicepersianAdd.component.scss']
})
export class DevicepersianAddComponent implements OnInit {

  Token:String=""

  constructor(
    private Devicepersian_Service:DevicepersianService,
    private Nav_Service:NavService,
    private Device_Service:DeviceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewDevicepersian=new FormGroup({
      id :new FormControl(),
      Dsc:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,1080).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewDevicepersian:FormGroup;

  get_Form_Dsc(){
    return this.AddNewDevicepersian.get('Dsc') as FormControl;
  }


  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDevicepersian(){
    var Record:Devicepersian_Interface =Empty_Devicepersian_Interface()
    Record.id=0
    Record.device_id=this.Data_Seleted_Record.id
    Record.dsc=this.get_Form_Dsc().value
    this.InProccessing=true
    this.Devicepersian_Service.AddDevicepersian(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered Persian name already exists in the list.")
        }
        else{
          this.AddNewDevicepersian.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }





    //#region Instrument

    modalRef_Device: any;
    page:number=0

    ProcssingDevice:boolean=false

    Search_Name_Device_Table:string=''
    Search_Code_Device_Table:string=''

    openModal_Device(template: TemplateRef<any>) {
      this.modalRef_Device = this.modalService.show(template);
    }

    DataList_Device:Array<Device_Interface>=[]
    Data_Seleted_Record:Device_Interface=Empty_Device_Interface()


    ReadData_Device_KeySearch_Timer:any
    ReadData_Device_KeySearch(){

      if (this.ReadData_Device_KeySearch_Timer) {
        clearTimeout(this.ReadData_Device_KeySearch_Timer);
        this.ReadData_Device_KeySearch_Timer = null;
    }

    this.ReadData_Device_KeySearch_Timer = setTimeout(function (){
      this.ReadData_Device()
    }.bind(this), 1000);

    }

    ReadData_Device(){


      if(!this.Search_Name_Device_Table)
      {
        this.DataList_Device=[]
      }
      else{
        this.ProcssingDevice=true
        this.Device_Service.GetSearchCalibration(this.Token,this.Search_Name_Device_Table,this.Search_Code_Device_Table).subscribe(
          data=>{
            this.DataList_Device=data
            this.ProcssingDevice=false
          },error=>{
            localStorage.clear()
            location.reload();

          }
        )
      }
    }

    Set_Selected_Device_Record(item){
      this.Data_Seleted_Record=item
      this.modalRef_Device.hide()
    }

    //#endregion

  }
